import React, { useEffect, useState } from 'react';
import { useNavigate,useLocation } from 'react-router-dom'; 
import '../mobileMenu/MobileMenu.css';
import red from '../../img/red.png';
import gray from '../../img/gray.png';

export const MobileMenuCompany = () => {
    const navigate = useNavigate();
    const location = useLocation();
  const [activeIndex, setActiveIndex] = useState(0);
  const images = [
    { src: gray, isActive: false,  title: 'Typ klienta', index: 0, url:'customers' },
    { src: gray, isActive: false,  title: 'Dane Firmy', index: 1,url:'companySearch'  },
    { src: gray, isActive: false,  title: 'Zgłoszenie', index: 2,url:'companyRegistration'  },
    { src: gray, isActive: false,  title: 'Miejsce odbioru towaru', index: 3,url:'companyReceiptGoods'  },
    { src: gray, isActive: false, title: 'Podsumowanie', index: 4,url:'companySummary'  },
  ];

  const handleImageClick = (index) => {
    if(activeIndex === index)
    {
      setActiveIndex(index);
      navigate(`/${images[index].url}`)
    }
  };

useEffect(()=>{
  const pathname = window.location.pathname;
  const index = images.findIndex((image)=>pathname.includes(image.url));
  if(index !== -1){
    setActiveIndex(index);
  }
},[images]);
  return (
    <div>
      <div className="mobile-menu-container">
        {images.map((image, index) => (
          <div key={index} style={{ color: 'black', padding: '0 2px' }}>
            <img
              src={activeIndex === index ? red : gray}
              onClick={() => handleImageClick(index)}
            />
          </div>
        ))}
      </div>
      <div className="mobile-menu-title">
        {images[activeIndex].title}
      </div>
    </div>
  );
};